module.exports = __webpack_public_path__ + "img/m08.3b6cb889.png";